/* ============================================================
   UNDERTONEZ THEME v2 — undertonez.js
   Cursor · Header scroll · Mobile nav · Cart drawer ·
   Scroll animations · FAQ · Marquee · Subscription toggle ·
   Review carousel
   ============================================================ */
(function () {
  'use strict';

  /* ── CURSOR ── */
  const cursor = document.getElementById('untzCursor');
  if (cursor && window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('mousemove', e => {
      cursor.style.left = e.clientX + 'px';
      cursor.style.top  = e.clientY + 'px';
    });
    document.querySelectorAll('a, button, .untz-product-card, .faq-item, .event-card, input').forEach(el => {
      el.addEventListener('mouseenter', () => cursor.classList.add('expand'));
      el.addEventListener('mouseleave', () => cursor.classList.remove('expand'));
    });
  }

  /* ── HEADER SCROLL ── */
  const header = document.querySelector('.untz-header');
  if (header) {
    const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── MOBILE NAV ── */
  const hamburger   = document.getElementById('untzHamburger');
  const mobileNav   = document.getElementById('untzMobileNav');
  const mobileClose = document.getElementById('untzMobileClose');
  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', () => {
      mobileNav.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
    const closeMobile = () => { mobileNav.classList.remove('open'); document.body.style.overflow = ''; };
    if (mobileClose) mobileClose.addEventListener('click', closeMobile);
    mobileNav.querySelectorAll('a').forEach(a => a.addEventListener('click', closeMobile));
  }

  /* ── SCROLL FADE-UP ── */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); } });
    }, { threshold: 0.1 });
    document.querySelectorAll('.fade-up').forEach((el, i) => {
      el.style.transitionDelay = ((i % 4) * 0.1) + 's';
      io.observe(el);
    });
  }

  /* ── FAQ ACCORDION ── */
  document.querySelectorAll('.faq-item').forEach(item => {
    item.addEventListener('click', () => {
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(f => {
        f.classList.remove('open');
        f.querySelector('.faq-toggle').textContent = '+';
      });
      if (!isOpen) { item.classList.add('open'); item.querySelector('.faq-toggle').textContent = '−'; }
    });
  });

  /* ── MARQUEE ── */
  const marquee = document.querySelector('.untz-marquee');
  if (marquee) {
    const t = marquee.querySelector('.untz-marquee-track');
    marquee.addEventListener('mouseenter', () => t && (t.style.animationPlayState = 'paused'));
    marquee.addEventListener('mouseleave', () => t && (t.style.animationPlayState = 'running'));
  }

  /* ── CART DRAWER ── */
  const cartDrawer  = document.getElementById('untzCartDrawer');
  const cartOverlay = document.getElementById('untzCartOverlay');
  const cartClose   = document.getElementById('untzCartClose');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    cartOverlay && cartOverlay.classList.add('visible');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartOverlay && cartOverlay.classList.remove('visible');
    document.body.style.overflow = '';
  }
  document.querySelectorAll('[data-open-cart]').forEach(b => b.addEventListener('click', e => { e.preventDefault(); openCart(); }));
  if (cartClose)   cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  /* ── CART API ── */
  function fetchCart() {
    fetch('/cart.js').then(r => r.json()).then(renderCart).catch(console.error);
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2) + ' CAD';
  }

  /* UNIFIED CART RENDERER FIX: Now uses item.key for targeting items cleanly */
  function renderCart(cart) {
    const body  = document.getElementById('cartDrawerBody');
    const total = document.getElementById('cartDrawerTotal');
    document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<p class="cart-empty-msg" style="color:#a09890;font-size:.88rem;padding:1rem 0">Your cart is empty.</p>';
      if (total) total.textContent = formatMoney(0);
    } else {
      body.innerHTML = cart.items.map(item => `
        <div class="cart-item" style="display:flex;gap:1rem;padding:1rem 0;border-bottom:1px solid rgba(255,255,255,.07)">
          <img src="${item.image}" alt="${item.product_title}" loading="lazy"
            style="width:64px;height:80px;object-fit:cover;flex-shrink:0;border-radius:2px">
          <div style="flex:1;display:flex;flex-direction:column;gap:.3rem">
            <div style="font-family:'Cormorant Garamond',serif;font-size:1rem;color:var(--cream)">${item.product_title}</div>
            ${item.variant_title !== 'Default Title' && item.variant_title !== 'null' && item.variant_title ? `<div style="font-size:.75rem;color:var(--mist)">${item.variant_title}</div>` : ''}
            <div style="color:#c9943a;font-size:.88rem">${formatMoney(item.line_price)}</div>
            <div style="display:flex;align-items:center;gap:.5rem;margin-top:auto;flex-wrap:wrap">
              <button type="button"
                onclick="window.untzUpdateItem('${item.key}', ${item.quantity - 1})"
                aria-label="Decrease quantity"
                style="background:none;border:1px solid rgba(255,255,255,.15);color:var(--cream);width:28px;height:28px;cursor:pointer;font-size:1rem;display:flex;align-items:center;justify-content:center;flex-shrink:0">−</button>
              <span style="font-size:.88rem;min-width:1.5rem;text-align:center;color:var(--cream)">${item.quantity}</span>
              <button type="button"
                onclick="window.untzUpdateItem('${item.key}', ${item.quantity + 1})"
                aria-label="Increase quantity"
                style="background:none;border:1px solid rgba(255,255,255,.15);color:var(--cream);width:28px;height:28px;cursor:pointer;font-size:1rem;display:flex;align-items:center;justify-content:center;flex-shrink:0">+</button>
              <button type="button"
                onclick="window.untzUpdateItem('${item.key}', 0)"
                aria-label="Remove item"
                style="background:none;border:none;color:var(--warm);font-size:.72rem;letter-spacing:.1em;text-transform:uppercase;cursor:pointer;margin-left:auto;padding:.2rem .4rem;transition:color .2s"
                onmouseover="this.style.color='#c0392b'"
                onmouseout="this.style.color='var(--warm)'">Remove</button>
            </div>
          </div>
        </div>`).join('');
    }
    if (total) total.textContent = formatMoney(cart.total_price);
  }

  window.untzAddToCart = function(variantId, qty) {
    const btn = document.querySelector(`button[onclick*="${variantId}"]`);
    if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    })
    .then(r => r.json())
    .then(() => {
      openCart();
      if (btn) { btn.textContent = 'Added ✓'; setTimeout(() => { btn.textContent = 'Add to Cart'; btn.disabled = false; }, 1500); }
    })
    .catch(err => { console.error(err); if (btn) { btn.textContent = 'Add to Cart'; btn.disabled = false; } });
  };

  /* FIXED API ENDPOINT SUBMISSION ROUTINE: Now maps via clean explicit unique item string keys */
  window.untzUpdateItem = function(itemKey, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: itemKey, quantity: parseInt(qty, 10) })
    })
    .then(r => r.json())
    .then(cart => renderCart(cart))
    .catch(console.error);
  };

  /* ── GALLERY THUMBS ── */
  document.querySelectorAll('.gallery-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const main = document.querySelector('.gallery-main');
      if (main) {
        main.src = thumb.dataset.full || thumb.src;
        document.querySelectorAll('.gallery-thumb').forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      }
    });
  });

  /* ── BUNDLE ADD TO CART ── */
  (function () {
    const bundleBtn   = document.getElementById('untzBundleBtn');
    const bundleLabel = document.getElementById('untzBundleBtnLabel');
    if (!bundleBtn) return;

    bundleBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (bundleBtn.classList.contains('loading')) return;

      bundleBtn.classList.add('loading');
      if (bundleLabel) bundleLabel.textContent = 'Adding…';
      bundleBtn.style.opacity = '.7';

      fetch('/collections/all/products.json?limit=10')
        .then(r => r.json())
        .then(data => {
          const products = data.products;
          const items = products
            .map(p => {
              const variant = p.variants.find(v => v.available) || p.variants[0];
              return variant ? { id: variant.id, quantity: 1 } : null;
            })
            .filter(Boolean)
            .slice(0, 3);

          if (items.length === 0) {
            if (bundleLabel) bundleLabel.textContent = 'Add Bundle to Cart →';
            bundleBtn.style.opacity = '1';
            bundleBtn.classList.remove('loading');
            return;
          }

          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items })
          });
        })
        .then(r => r && r.json())
        .then(() => {
          if (bundleLabel) bundleLabel.textContent = 'Added ✓';
          bundleBtn.style.opacity = '1';
          bundleBtn.classList.remove('loading');
          openCart();
          setTimeout(() => {
            if (bundleLabel) bundleLabel.textContent = 'Add Bundle to Cart →';
          }, 2000);
        })
        .catch(err => {
          console.error('Bundle add error:', err);
          if (bundleLabel) bundleLabel.textContent = 'Error — try again';
          bundleBtn.style.opacity = '1';
          bundleBtn.classList.remove('loading');
          setTimeout(() => {
            if (bundleLabel) bundleLabel.textContent = 'Add Bundle to Cart →';
          }, 2500);
        });
    });
  })();

  /* ── SUBSCRIPTION FREQUENCY TOGGLE ── */
  (function () {
    const toggle = document.getElementById('freqToggle');
    if (!toggle) return;
    const pricing = {
      monthly:   { single: ['$11','Save $1 / delivery'], double: ['$21','Save $3 / delivery'], bundle: ['$27','Save $3 / delivery'] },
      bimonthly: { single: ['$11','Save $1 / delivery'], double: ['$21','Save $3 / delivery'], bundle: ['$26','Save $4 / delivery'] },
      quarterly: { single: ['$10','Save $2 / delivery'], double: ['$20','Save $4 / delivery'], bundle: ['$25','Save $5 / delivery'] }
    };
    function applyFreq(freq) {
      const p = pricing[freq];
      const set = (id, badgeId, price, badge) => {
        const el = document.getElementById(id);
        const bdg = document.getElementById(badgeId);
        if (el)  el.innerHTML = price + ' <small>CAD / delivery</small>';
        if (bdg) bdg.textContent = badge;
      };
      set('price-single', 'badge-single', p.single[0], p.single[1]);
      set('price-double', 'badge-double', p.double[0], p.double[1]);
      set('price-bundle', 'badge-bundle', p.bundle[0], p.bundle[1]);
    }
    toggle.querySelectorAll('.freq-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        toggle.querySelectorAll('.freq-btn').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        applyFreq(btn.dataset.freq);
      });
    });
  })();

  /* ── REVIEW CAROUSEL ── */
  (function () {
    const track    = document.getElementById('reviewTrack');
    const prevBtn  = document.getElementById('carouselPrev');
    const nextBtn  = document.getElementById('carouselNext');
    const dotsWrap = document.getElementById('carouselDots');
    if (!track) return;

    const cards = track.querySelectorAll('.review-card');
    const total = cards.length;
    let current = 0, autoTimer;

    const cardW  = () => cards[0].offsetWidth + 20;
    const visCount = () => Math.max(1, Math.floor(track.parentElement.offsetWidth / cardW()));
    const pages  = () => Math.ceil(total / visCount());

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      for (let i = 0; i < pages(); i++) {
        const d = document.createElement('button');
        d.className = 'cdot' + (i === 0 ? ' active' : '');
        d.setAttribute('aria-label', 'Page ' + (i + 1));
        d.addEventListener('click', () => { goTo(i * visCount()); resetAuto(); });
        d.appendChild(d);
      }
    }

    function updateDots() {
      if (!dotsWrap) return;
      const page = Math.floor(current / visCount());
      dotsWrap.querySelectorAll('.cdot').forEach((d, i) => d.classList.toggle('active', i === page));
    }

    function goTo(idx) {
      current = Math.max(0, Math.min(idx, total - visCount()));
      track.style.transform = 'translateX(-' + (current * cardW()) + 'px)';
      updateDots();
    }

    if (prevBtn) prevBtn.addEventListener('click', () => { goTo(current - visCount()); resetAuto(); });
    if (nextBtn) nextBtn.addEventListener('click', () => { goTo(current + visCount()); resetAuto(); });

    function startAuto() {
      autoTimer = setInterval(() => goTo(current + visCount() >= total ? 0 : current + visCount()), 4500);
    }
    function resetAuto() { clearInterval(autoTimer); startAuto(); }

    let touchX = 0;
    track.addEventListener('touchstart', e => { touchX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', e => {
      const diff = touchX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) { diff > 0 ? goTo(current + visCount()) : goTo(current - visCount()); resetAuto(); }
    });

    buildDots(); startAuto();
    window.addEventListener('resize', () => { buildDots(); goTo(0); });
  })();

  /* ── EMAIL FORM ── */
  const emailForm = document.getElementById('untzEmailForm');
  if (emailForm) {
    emailForm.addEventListener('submit', e => {
      e.preventDefault();
      const email = emailForm.querySelector('input[type="email"]').value;
      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: 'form_type=customer&utf8=%E2%9C%93&contact[email]=' + encodeURIComponent(email) + '&contact[tags]=newsletter'
      }).then(() => {
        emailForm.innerHTML = '<p style="font-size:.9rem;font-weight:500;color:var(--black)">✓ You\'re in! Check your email for your 15% off code.</p>';
      }).catch(() => {
        emailForm.innerHTML = '<p style="font-size:.88rem;color:var(--black)">Something went wrong. Email us at undertonezinc@gmail.com</p>';
      });
    });
  }

})();